import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi
} from '@angular/common/http';
import {OnHttpRequestInterceptor} from './core/interceptors/on-http-request-interceptor.service';
import {OnHttpResponseInterceptor} from './core/interceptors/on-http-response-interceptor.service';
import {loadingInterceptor} from './core/interceptors/loading.interceptor';
import {ThemeService} from './shared/services/theme.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([loadingInterceptor])
    ),
    { provide: HTTP_INTERCEPTORS, useClass: OnHttpRequestInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: OnHttpResponseInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: (themeService: ThemeService) => () => themeService.loadInitialTheme(),
      deps: [ThemeService],
      multi: true
    }
  ]
};
